import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = ""; // same-origin now — Vercel rewrites /api/* to the backend (see client/vercel.json). Keeps the session cookie first-party for Safari/Firefox.

function AdBanner({ onClose }) {
  return (
    <div style={{
      background: "linear-gradient(135deg, #1a1a2e, #16213e)",
      border: "1px solid #2a2a4a",
      borderRadius: 10,
      padding: "10px 16px",
      margin: "0 16px 16px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }}>
      <div>
        <span style={{ color: "#555", fontSize: 9, textTransform: "uppercase", letterSpacing: 1 }}>Advertisement</span>
        <p style={{ color: "#aaa", margin: "2px 0 0 0", fontSize: 13 }}>
          🌟 Upgrade to Ultra Pro — Ad-Free experience ke liye!
        </p>
      </div>
      <span onClick={onClose} style={{ color: "#FF6B00", fontSize: 18, cursor: "pointer", padding: "0 4px" }}>✕</span>
    </div>
  );
}

export default function History() {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [adVisible, setAdVisible] = useState(true);
  const token = localStorage.getItem("subai_session"); // non-sensitive "am I logged in" flag now — real session is the httpOnly cookie

  useEffect(() => {
    if (!token) { navigate("/"); return; }
    fetch(`${API}/api/my-uploads`, {
      headers: { Authorization: "Bearer " + token }
    }).then(r => r.json())
      .then(d => { setFiles(d.uploads || []); setLoading(false); })
      .catch(() => setLoading(false));

    fetch(`${API}/api/profile`, {
      headers: { Authorization: "Bearer " + token }
    }).then(r => r.json())
      .then(d => setProfile(d))
      .catch(() => {});
  }, []);

  const deleteFile = async (id) => {
    if (!window.confirm("Yeh file delete karna chahte ho?")) return;
    setFiles(prev => prev.filter(f => f._id !== id));
    try {
      await fetch(`${API}/api/delete/${id}`, {
        method: "DELETE",
        headers: { Authorization: "Bearer " + token }
      });
    } catch {}
  };

  const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

  // Group by date
  const grouped = files.reduce((acc, f) => {
    const key = fmtDate(f.createdAt);
    if (!acc[key]) acc[key] = [];
    acc[key].push(f);
    return acc;
  }, {});

  const converted = files.filter(f => f.convertedPath).length;
  const edited    = files.filter(f => f.editedPath).length;

  return (
    <div style={styles.page}>

      {/* Navbar */}
      <div style={styles.navbar}>
        <button onClick={() => navigate("/dashboard")} style={styles.backBtn}>←</button>
        <span style={styles.navTitle}>📜 History</span>
        <div style={{ width: 36 }} />
      </div>

      {/* Ad Banner */}
      {adVisible && profile?.showAds && (
        <AdBanner onClose={() => setAdVisible(false)} />
      )}

      {/* Stats row — always visible */}
      {!loading && files.length > 0 && (
        <div style={styles.statsRow}>
          <Stat icon="📄" val={files.length} label="Total" />
          <Stat icon="⚡" val={converted} label="Converted" color="#FF6B00" />
          <Stat icon="✏️" val={edited}    label="Edited"    color="#7B61FF" />
        </div>
      )}

      <div style={styles.container}>

        {/* Loading */}
        {loading && (
          <div style={styles.center}>
            <div style={styles.spinner} />
            <p style={{ color: "#555", marginTop: 14, fontSize: 13 }}>Load ho raha hai...</p>
          </div>
        )}

        {/* Empty */}
        {!loading && files.length === 0 && (
          <div style={styles.emptyBox}>
            <span style={{ fontSize: 56 }}>📭</span>
            <h3 style={styles.emptyTitle}>Koi history nahi hai</h3>
            <p style={styles.emptyText}>Files upload ya convert karne ke baad yahan dikhenge</p>
            <button onClick={() => navigate("/dashboard")} style={styles.goBtn}>
              Dashboard pe Jao →
            </button>
          </div>
        )}

        {/* Grouped file list */}
        {!loading && Object.entries(grouped).map(([date, dayFiles]) => (
          <div key={date} style={styles.group}>
            <div style={styles.dateLabel}>{date}</div>
            {dayFiles.map(f => (
              <FileCard
                key={f._id}
                file={f}
                time={fmtTime(f.createdAt)}
                onEdit={() => navigate("/editor/" + f._id)}
                onDelete={() => deleteFile(f._id)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

function FileCard({ file, time, onEdit, onDelete }) {
  const name = file.fileName || "Unknown";
  const converted = !!file.convertedPath;
  const edited    = !!file.editedPath;

  return (
    <div style={styles.card}>
      {/* Icon */}
      <div style={{ ...styles.iconBox, background: converted ? "#FF6B0018" : "#181818" }}>
        <span style={{ fontSize: 22 }}>📄</span>
        <span style={{ fontSize: 9, fontWeight: 700, color: converted ? "#FF6B00" : "#444", letterSpacing: 0.5 }}>
          {name.split(".").pop().toUpperCase()}
        </span>
      </div>

      {/* Info */}
      <div style={styles.cardInfo}>
        <div style={styles.cardName}>{name.length > 26 ? name.slice(0, 23) + "…" : name}</div>
        <div style={styles.cardMeta}>
          🕐 {time}
          {converted && <span style={styles.tagOrange}>⚡ Converted</span>}
          {edited    && <span style={styles.tagPurple}>✏️ Edited</span>}
        </div>
      </div>

      {/* Actions */}
      <div style={styles.actions}>
        <button onClick={onEdit} style={styles.iconBtn} title="Edit">✏️</button>
        {file.convertedPath && (
          <a href={`${API}/${file.convertedPath}`} download style={{ ...styles.iconBtn, textDecoration: "none" }} title="Download">⬇</a>
        )}
        <button onClick={onDelete} style={{ ...styles.iconBtn, color: "#ff4444" }} title="Delete">🗑</button>
      </div>
    </div>
  );
}

function Stat({ icon, val, label, color }) {
  return (
    <div style={styles.statBox}>
      <span style={{ fontSize: 20 }}>{icon}</span>
      <span style={{ fontSize: 22, fontWeight: 800, color: color || "#E8E8E8" }}>{val}</span>
      <span style={{ fontSize: 10, color: "#555", textTransform: "uppercase", letterSpacing: 1 }}>{label}</span>
    </div>
  );
}

const styles = {
  page: { minHeight: "100vh", background: "#0D0D0D", color: "#E8E8E8", fontFamily: "sans-serif" },

  navbar: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "14px 16px", borderBottom: "1px solid #1a1a1a",
    position: "sticky", top: 0, background: "#0D0D0D", zIndex: 10,
  },
  backBtn: {
    background: "none", border: "1px solid #2a2a2a", color: "#aaa",
    width: 36, height: 36, borderRadius: 10, cursor: "pointer", fontSize: 18,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  navTitle: { fontSize: 16, fontWeight: 700 },

  statsRow: {
    display: "grid", gridTemplateColumns: "repeat(3, 1fr)",
    gap: 1, borderBottom: "1px solid #1a1a1a",
    background: "#111",
  },
  statBox: {
    display: "flex", flexDirection: "column", alignItems: "center",
    padding: "14px 8px", gap: 3, background: "#111",
  },

  container: { padding: "16px 16px 80px 16px", maxWidth: 600, margin: "0 auto" },

  center: { display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 80 },
  spinner: { width: 32, height: 32, border: "3px solid #222", borderTop: "3px solid #FF6B00", borderRadius: "50%", animation: "spin 0.8s linear infinite" },

  emptyBox: { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", paddingTop: 60, gap: 10 },
  emptyTitle: { color: "#ccc", fontSize: 18, margin: 0 },
  emptyText: { color: "#555", fontSize: 13, margin: 0, maxWidth: 260 },
  goBtn: {
    marginTop: 8, padding: "12px 24px",
    background: "linear-gradient(135deg, #FF6B00, #e05500)",
    border: "none", borderRadius: 12, color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14,
  },

  group: { marginBottom: 20 },
  dateLabel: {
    fontSize: 10, color: "#444", textTransform: "uppercase",
    letterSpacing: 2, padding: "6px 0 10px 0",
    borderBottom: "1px solid #1a1a1a", marginBottom: 10,
  },

  card: {
    background: "#161616", border: "1px solid #1e1e1e",
    borderRadius: 14, padding: "14px 14px",
    display: "flex", alignItems: "center", gap: 12,
    marginBottom: 8,
  },
  iconBox: {
    width: 46, height: 46, borderRadius: 12, flexShrink: 0,
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2,
  },
  cardInfo: { flex: 1, minWidth: 0 },
  cardName: { fontSize: 13, fontWeight: 600, color: "#E8E8E8", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  cardMeta: { display: "flex", alignItems: "center", gap: 6, marginTop: 4, color: "#555", fontSize: 11, flexWrap: "wrap" },
  tagOrange: { background: "#FF6B0020", color: "#FF6B00", padding: "2px 7px", borderRadius: 5, fontSize: 10, fontWeight: 700 },
  tagPurple: { background: "#7B61FF20", color: "#7B61FF", padding: "2px 7px", borderRadius: 5, fontSize: 10, fontWeight: 700 },

  actions: { display: "flex", gap: 6, flexShrink: 0 },
  iconBtn: {
    background: "#1e1e1e", border: "1px solid #2a2a2a", color: "#aaa",
    width: 32, height: 32, borderRadius: 8, cursor: "pointer", fontSize: 14,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
};
